import { ExtraMileBanner } from './ExtraMileBanner'
import { FullWidth2Col } from './FullWidth2Col'

export const components = {
  extra_mile_banner: ExtraMileBanner,
  full_width_2_col: FullWidth2Col,
}
